/**
 * @file コンポーネント：フル動画ページ関連症例 ロジック管理
 */

// ライブラリ読み込み
import React, { useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const RelatedCases = (props) => {
    /**
     * コンテンツ開閉状態
     */
    const [isOpen, setIsOpen] = useState(props.isOpen);

    // Presenterに渡す
    return <Presenter {...props} isOpen={isOpen} setIsOpen={setIsOpen} />;
};
